import { Download, Trash2, FileText, FileImage, FileVideo, FileAudio, FileCode2, File as FileIcon } from "lucide-react";
import { workspaceDownloadUrl } from "@/lib/api";

function iconFor(ct) {
    if (!ct) return FileIcon;
    if (ct.startsWith("image/")) return FileImage;
    if (ct.startsWith("video/")) return FileVideo;
    if (ct.startsWith("audio/")) return FileAudio;
    if (ct.includes("javascript") || ct.includes("json") || ct.includes("xml") || ct.includes("html") || ct.includes("css")) return FileCode2;
    if (ct.startsWith("text/") || ct === "application/pdf") return FileText;
    return FileIcon;
}

function fmtBytes(n) {
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
    if (n < 1024 ** 3) return `${(n / 1024 / 1024).toFixed(1)} MB`;
    return `${(n / 1024 ** 3).toFixed(2)} GB`;
}

export default function FileRow({ file, onDelete }) {
    const Icon = iconFor(file.content_type);
    return (
        <div
            data-testid={`file-row-${file.id}`}
            className="
                flex items-center gap-3 px-4 py-3 border-b border-tca-ink-dim/25
                hover:bg-tca-cyan/3 transition-colors duration-200
            "
        >
            <Icon size={16} strokeWidth={1.5} className="text-tca-cyan shrink-0" />
            <div className="flex-1 min-w-0">
                <div className="text-sm text-tca-ink truncate">{file.filename}</div>
                <div className="font-mono-tight text-[10px] uppercase tracking-[0.18em] text-tca-ink-muted mt-0.5">
                    {fmtBytes(file.size)} · {new Date(file.uploaded_at).toLocaleString()}
                </div>
            </div>
            <a
                href={workspaceDownloadUrl(file.id)}
                target="_blank"
                rel="noreferrer"
                data-testid={`file-download-${file.id}`}
                className="p-2 text-tca-ink-muted hover:text-tca-cyan transition-colors"
                title="Download"
            >
                <Download size={14} />
            </a>
            <button
                type="button"
                onClick={() => onDelete?.(file)}
                data-testid={`file-delete-${file.id}`}
                className="p-2 text-tca-ink-muted hover:text-tca-magenta-accent transition-colors"
                title="Delete"
            >
                <Trash2 size={14} />
            </button>
        </div>
    );
}
